import { Modal } from "bootstrap";

class Cookies {
  constructor(node) {
    this.element = node;
    this.cookiePreferencesForm = this.element.querySelector(".js-cookie-preferences-form");
    this.cookieBar = this.element.querySelector(".js-cookie-bar");

    if (this.cookieBar) {
      this.rejectButton = this.element.querySelector(".js-reject-cookies");
      this.acceptAllButton = this.element.querySelector(".js-accept-all-cookies");

      if (document.cookie.includes("cookie_preference")) {
        this.hideCookieBar();
      } else {
        this.cookieBar.classList.remove("fade");
      }

      this.initializeCookieBar();
    }

    this.initialize();
  }

  initialize() {
    this.cookiePreferencesForm.addEventListener("submit", (e) => {
      e.preventDefault();
      const modal = Modal.getInstance(".js-cookie-modal");
      const formData = new FormData(e.currentTarget);

      this.setCookie(formData.getAll("cookie-preference[]"));
      modal.hide();

      if (this.cookieBar) {
        this.hideCookieBar();
      }
    });
  }

  initializeCookieBar() {
    this.rejectButton.addEventListener("click", () => {
      this.setCookie(["functional"]);
      this.hideCookieBar();
    });

    this.acceptAllButton.addEventListener("click", () => {
      this.setCookie(["functional", "analytical", "third-party"]);
      this.hideCookieBar();
    });
  }

  hideCookieBar() {
    this.cookieBar.classList.add("fade");

    setTimeout(() => {
      this.cookieBar.remove();
    }, 300); // Same duration as the css animation
  }

  setCookie(preference) {
    const date = new Date();
    const expirationDate = new Date(date.setMonth(date.getMonth() + 12));

    document.cookie = `cookie_preference=${JSON.stringify(preference)}; expires=${expirationDate.toUTCString()}; samesite=strict; domain=${window.location.hostname}; path=/`;
  }
}

const cookies = document.querySelector("[data-js='cookies']");

if (cookies) {
  new Cookies(cookies);
}
